import type {
  LiveSubagentTimelineItem as LiveSubagentTimelineItemContract,
  ScopedThreadRef,
  ServerProviderSkill,
} from "@t3tools/contracts";
import { memo } from "react";

import { AssistantMessageContent } from "./chat/AssistantMessageContent";
import { WorkEntryPresentation } from "./chat/WorkEntryPresentation";
import { presentLiveSubagentTimelineItem } from "./liveSubagentPresentation";

interface LiveSubagentTimelineItemProps {
  readonly item: LiveSubagentTimelineItemContract;
  readonly markdownCwd: string | undefined;
  readonly threadRef: ScopedThreadRef;
  readonly skills: ReadonlyArray<Pick<ServerProviderSkill, "name" | "displayName">>;
  readonly workspaceRoot: string | undefined;
}

export const LiveSubagentTimelineItem = memo(function LiveSubagentTimelineItem({
  item,
  markdownCwd,
  threadRef,
  skills,
  workspaceRoot,
}: LiveSubagentTimelineItemProps) {
  const presentation = presentLiveSubagentTimelineItem(item);

  if (presentation.kind === "assistant") {
    return (
      <div className="min-w-0 px-3 py-2" data-live-subagent-item-kind="assistant">
        <AssistantMessageContent
          text={presentation.text}
          cwd={markdownCwd}
          threadRef={threadRef}
          isStreaming={presentation.isStreaming}
          skills={skills}
        />
      </div>
    );
  }

  return (
    <div className="min-w-0 px-3 py-1" data-live-subagent-item-kind="work">
      <WorkEntryPresentation
        workEntry={presentation.workEntry}
        workspaceRoot={workspaceRoot}
        turnSettled={presentation.turnSettled}
      />
    </div>
  );
});
